import type { Action, Reducer, State } from '../use_candidate_profile';

export const agreementsReducer: Reducer = (state: State, action: Action) => {
  switch (action.type) {
    case 'deleteAgreement': {
      const { payload } = action;
      if (!state.agreements) {
        return state;
      }

      return {
        ...state,
        agreements: state.agreements.filter(
          (agreement) => agreement.id !== payload.id
        ),
      };
    }
    case 'addAgreement': {
      const { payload } = action;
      if (!state.agreements) {
        return state;
      }

      return {
        ...state,
        agreements: [...state.agreements, payload],
      };
    }
    case 'addAgreements': {
      const { payload } = action;
      return {
        ...state,
        agreements: payload,
      };
    }
    default: {
      return state;
    }
  }
};
